module.exports = __webpack_public_path__ + "static/media/sns-icon-vimeo.cd44997d.svg";